import { FC } from 'react';

import { Field } from '@savgroup-front-common/core/src/molecules/Field';

import { useGetFileSummaryNewUi } from '../../FileSummaryNewUi.hooks';
import { messages } from '../../messages';

export const StoreActorField: FC = () => {
  const { data } = useGetFileSummaryNewUi();
  const storeActorName = data?.context.storeActorName;

  if (!storeActorName) {
    return null;
  }

  return (
    <Field label={messages.storeActor} copy={storeActorName}>
      {storeActorName}
    </Field>
  );
};
